import { render, staticRenderFns } from "./VvBox.vue?vue&type=template&id=ecb242f0&scoped=true&"
import script from "./VvBox.vue?vue&type=script&lang=js&"
export * from "./VvBox.vue?vue&type=script&lang=js&"
import style0 from "./VvBox.vue?vue&type=style&index=0&id=ecb242f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb242f0",
  null
  
)

export default component.exports